import React, { useState, useEffect } from "react";
import CentroArcade from "./dashboard/arcade/CentroArcade";

export default function Layout({ children }) {
  const [esModoOscuro, setEsModoOscuro] = useState(false);
  const [festividad, setFestividad] = useState({ id: "", nombre: "", icono: "", claseCSS: "" });
  const [mostrarInsignia, setMostrarInsignia] = useState(true);
  const [iniciarDesvanecimiento, setIniciarDesvanecimiento] = useState(false);

  useEffect(() => {
    // 1. Detección de hora (Modo Noche / Día)
    const verificarHoraSistema = () => {
      const horaActual = new Date().getHours();
      setEsModoOscuro(horaActual >= 17 || horaActual < 5);
    };

    // 2. Detección automática de festividades durante todo el año
    const verificarFestividad = () => {
      const hoy = new Date();
      const mes = hoy.getMonth() + 1;
      const dia = hoy.getDate();

      if (mes === 10) {
        setFestividad({ id: "halloween", nombre: "Temporada de Halloween", icono: "🎃🕸️", claseCSS: "festivity-halloween" });
      } else if (mes === 12 || (mes === 1 && dia <= 6)) {
        setFestividad({ id: "navidad", nombre: "Navidad y Fiestas Decembrinas", icono: "🎄❄️", claseCSS: "festivity-navidad" });
      } else if (mes === 9) {
        setFestividad({ id: "amor", nombre: "Mes de Amor y Amistad", icono: "💖💌", claseCSS: "festivity-amor" });
      } else if (mes === 1 && dia > 6) {
        setFestividad({ id: "anionuevo", nombre: "Próspero Año Nuevo", icono: "🎉✨", claseCSS: "festivity-anionuevo" });
      } else if (mes === 2) {
        setFestividad({ id: "carnaval", nombre: "Temporada de Carnavales", icono: "🎭🎉", claseCSS: "festivity-carnaval" });
      } else if (mes === 4) {
        setFestividad({ id: "pascua", nombre: "Temporada de Pascua", icono: "🐰🌷", claseCSS: "festivity-pascua" });
      } else if (mes === 5 || mes === 6) {
        setFestividad({ id: "familias", nombre: "Mes de las Familias", icono: "👨‍👩‍👧‍👦💐", claseCSS: "festivity-familias" });
      } else if (mes === 7 || mes === 8) {
        setFestividad({ id: "patrio", nombre: "Fiestas Patrias e Independencia", icono: "🇨🇴🎇", claseCSS: "festivity-patrio" });
      } else {
        setFestividad({ id: "", nombre: "", icono: "", claseCSS: "" });
      }
    };

    verificarHoraSistema();
    verificarFestividad();

    // Insignia visible por 4.5 segundos antes de desvanecerse de forma fluida
    const timerFade = setTimeout(() => {
      setIniciarDesvanecimiento(true);
    }, 4500);

    const timerHide = setTimeout(() => {
      setMostrarInsignia(false);
    }, 5200);

    const intervalo = setInterval(verificarHoraSistema, 300000);
    return () => {
      clearTimeout(timerFade);
      clearTimeout(timerHide);
      clearInterval(intervalo);
    };
  }, []);

  return (
    <div className={`min-h-screen w-full relative overflow-x-hidden flex flex-col items-center transition-colors duration-700 ${esModoOscuro ? 'theme-dark' : 'theme-light'} ${festividad.claseCSS}`}>
      
      {/* INSIGNIA FLOTANTE (Dura 5 segundos y se desvanece con animación) */}
      {festividad.id && mostrarInsignia && (
        <div className={`fixed top-4 right-4 z-[9999] hidden sm:flex items-center gap-2.5 bg-white/90 dark:bg-slate-900/95 backdrop-blur-2xl px-6 py-3 rounded-full border border-white shadow-2xl transition-all duration-700 ${iniciarDesvanecimiento ? 'opacity-0 scale-95 translate-y-[-10px]' : 'opacity-100 scale-100 translate-y-0'}`}>
          <span className="text-2xl animate-bounce">{festividad.icono}</span>
          <div className="flex flex-col">
            <span className="text-xs font-black uppercase tracking-wider text-slate-900 dark:text-white">{festividad.nombre}</span>
            <span className="text-[9px] font-bold text-slate-500">Modo Estacional Automático </span>
          </div>
        </div>
      )}

      {/* OBJETOS DECORATIVOS DISPERSOS POR TODA LA PANTALLA (Z-INDEX 50) */}
      {festividad.id === "halloween" && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-50">
          <div className="spider-hanging absolute top-0 left-[8%] text-3xl">🕷️</div>
          <div className="spider-hanging absolute top-0 left-[28%] text-3xl" style={{ animationDelay: '1.5s' }}>🦇</div>
          <div className="spider-hanging absolute top-0 left-[55%] text-3xl" style={{ animationDelay: '0.8s' }}>🕷️</div>
          <div className="spider-hanging absolute top-0 left-[78%] text-3xl" style={{ animationDelay: '2.1s' }}>🦇</div>
          <div className="absolute top-[35%] left-[2%] text-2xl animate-pulse">👻</div>
          <div className="absolute top-[65%] right-[2%] text-2xl animate-bounce">🎃</div>
        </div>
      )}

      {festividad.id === "navidad" && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-50">
          <div className="absolute top-0 left-[10%] text-2xl animate-bounce">❄️</div>
          <div className="absolute top-0 left-[35%] text-2xl animate-pulse">⭐</div>
          <div className="absolute top-0 left-[65%] text-2xl animate-bounce">❄️</div>
          <div className="absolute top-0 left-[90%] text-2xl animate-pulse">🎄</div>
          <div className="absolute top-[40%] left-[3%] text-2xl animate-pulse">🎁</div>
          <div className="absolute top-[70%] right-[3%] text-2xl animate-bounce">⛄</div>
        </div>
      )}

      {festividad.id === "amor" && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-50">
          <div className="absolute top-0 left-[15%] text-2xl animate-bounce">💖</div>
          <div className="absolute top-0 left-[50%] text-2xl animate-pulse">💌</div>
          <div className="absolute top-0 left-[85%] text-2xl animate-bounce">💘</div>
        </div>
      )}

      {festividad.id === "anionuevo" && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-50">
          <div className="absolute top-0 left-[20%] text-2xl animate-bounce">✨</div>
          <div className="absolute top-0 left-[60%] text-2xl animate-pulse">🎉</div>
        </div>
      )}

      {/* Contenedor principal de la app */}
      <main className="w-full flex-1 flex flex-col relative z-10 animate-fade-in">
        {children}
      </main>

      {/* Botón flotante del Arcade */}
      <div className="relative z-50">
        <CentroArcade />
      </div>
    </div>
  );
}